export function getBarSeries (type) {
 let dimensions = [];
 let source = [];
 let color = [
  "#F6836E",
  "#FF9F4B",
  "#F6CE6E",
  "#F0681C",
  "#0188CC",
  "#025FBA",
  "#042E93",
 ]
 type.forEach((t) => {
  dimensions.push(t.name);
  source.push(t.value);
 });

 return {
  tooltip: {},
  xAxis: {
   type: "category",
   axisLabel: {
    show: true,
    textStyle: {
     color: "#A6CAFF",
     fontSize: "16",
    },
    axisLine: {
     lineStyle: {
      color: "#8A9099",
      type: "dashed",
     },
    },
   },
   data: dimensions
  },
  yAxis: {
   max: 100,
   axisLabel: {
    show: true,
    textStyle: {
     color: "#A6CAFF",
     fontSize: "16",
    },
   },
   // splitNumber: 4,
   axisLine: {
    show: false,
   },
  },
  series: [{
   data: source,
   type: 'bar',
   showBackground: true,
   barMaxWidth: '30%',
   itemStyle: {
    normal: {
     color: function (params) {
      return color[params.dataIndex % 7];
     }
    }
   }
  }]
 };
}

export function getPieSeries (type) {
 const colorList = ['#3BDEFF', '#5c5886'];
 return {
  tooltip: {
   trigger: "item",
   formatter: "{a} <br/>{b}: {d}%",
  },
  grid: {
  //  top: "50%"
  },
  title: {
    text: '设备态势',
    left:'center',
    top: '41%',
    textStyle:{
      color:'#fff',
      fontSize: 16
    }
  },
  series: [
   {
    name: "设备态势",
    type: "pie",
    selectedMode: "single",
    radius: ["60%", "91%"],
    label: {
     position: "inner",
     show: false,
    },
    itemStyle: {
      normal: {
        color: function(params) {
          console.log("params", params)
          return colorList[params.dataIndex]
        }
      }
    },
    labelLine: {
     show: false,
    },
    data: type,
   },
  ],
 };
}

export function getRunPointSeries (value,color1,color2) {

  return  {
    /*title: {
      text: value + '%',
      x: 'center',
      y: 'center',
      textStyle: {
        fontWeight: 'normal',
        color: '#fff',
        fontSize: '20'
      }
    },*/
    color: '#384a6b',
    series: [{
      name: 'Line 1',
      type: 'pie',
      clockWise: true,
      radius: ['50%', '66%'],
      itemStyle: {
        normal: {
          label: {
            show: false
          },
          labelLine: {
            show: false
          }
        }
      },
      hoverAnimation: false,
      roundCap: true,
      data: [{
        value: value,
        name: '01',
        itemStyle: {
          normal: {
            color: { // 完成的圆环的颜色
              colorStops: [{
                offset: 0,
                color: color1 // 0% 处的颜色
              }, {
                offset: 1,
                color: color2 // 100% 处的颜色
              }]
            },
            label: {
              show: false
            },
            labelLine: {
              show: false
            }
          }
        }
      }, {
        name: '02',
        value: 100 - value,
      }]
    }]
  };
}
